import Text from 'components/Text/Text';
import { IRestaurantCategory } from 'types';
import React, { useMemo } from 'react';
import style from './CategoriesList.module.scss';

interface ICategoriesList {
	initialCategories: IRestaurantCategory[];
}

const CategoriesList: React.FC<ICategoriesList> = ({ initialCategories }) => {
	const categoriesList = useMemo(() => {
		return initialCategories.map((el) => (
			<div className={style.item} key={el.id}>
				<div className={style.dot} />
				<Text translationKey={el.name} withTooltip={true} />
			</div>
		));
	}, [initialCategories]);

	return (
		<div data-test="CategoriesList">
			<Text translationNameSpace="form" translationKey="categoryHeading" theme="neutralLight" size="xs" />
			<div className={style.listOfItems}>{initialCategories.length ? categoriesList : '-'}</div>
		</div>
	);
};

export default React.memo(CategoriesList);
